module.exports = __webpack_public_path__ + "static/media/hacktoberfest01.2f7d2b4f.png";